import { render, staticRenderFns } from "./PublishReportDialog.vue?vue&type=template&id=879795b0&scoped=true&"
import script from "./PublishReportDialog.vue?vue&type=script&lang=js&"
export * from "./PublishReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./PublishReportDialog.vue?vue&type=style&index=0&id=879795b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879795b0",
  null
  
)

export default component.exports